import classNames from 'classnames';
import React from 'react';
import Style from 'styles/components/page_nation.module.scss';
import { Link } from "gatsby";

const PageNation = ({ page, currentPage, totalPages }) => {
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <div className={classNames(Style.pagination)}>
      {/* ← 前へ */}
      {currentPage > 1 && (
        <Link
          to={`${page}?page=${currentPage - 1}`}
          className={classNames(Style.pagination__link)}
        >
          ← 前へ
        </Link>
      )}

      {/* ページ番号 */}
      {pages.map((p) => {
        return p === currentPage ? (
          <span key={p} className={classNames(Style.active)}>{p}</span>
        ) : (
          <Link
            key={p}
            to={`${page}?page=${p}`}
            className={classNames(Style.pagination__link)}
          >
            {p}
          </Link>
        );
      })}

      {/* 次へ → */}
      {currentPage < totalPages && (
        <Link
          to={`${page}?page=${currentPage + 1}`}
          className={classNames(Style.pagination__link)}
        >
          次へ →
        </Link>
      )}
    </div>
  );
};

export default PageNation;
